// Renders loading / error states for a react-query result and hands the
// resolved data to a render prop. Keeps each tab's success path terse.
import type { ReactNode } from 'react';

interface QueryStateProps<T> {
  idBase: string;
  isPending: boolean;
  isError: boolean;
  error: unknown;
  data: T | undefined;
  children: (data: T) => ReactNode;
}

export function QueryState<T>({
  idBase,
  isPending,
  isError,
  error,
  data,
  children,
}: QueryStateProps<T>) {
  if (isPending) {
    return (
      <div data-id={`${idBase}--loading`} className="p-4 text-sm text-slate-500">
        Loading…
      </div>
    );
  }
  if (isError) {
    return (
      <div data-id={`${idBase}--error`} className="p-4 text-sm text-red-600 dark:text-red-400">
        {error instanceof Error ? error.message : 'Failed to load'}
      </div>
    );
  }
  if (data === undefined) {
    return (
      <div data-id={`${idBase}--empty`} className="p-4 text-sm text-slate-500">
        No data.
      </div>
    );
  }
  return <>{children(data)}</>;
}
